<template>
    <el-dialog
        :title="title"
        width="500px"
        append-to-body
        destroy-on-close
        :modal="true"
        :visible.sync="dialogFormVisible"
        :close-on-click-modal="false"
        @close="$emit('input', false)"
    >
        <el-form ref="clueForm" :model="form" label-width="100px" style="width: 80%">
            <el-form-item label="售前负责人" size="small">
                <el-select v-model="form.pre_sale_principal" placeholder="请选择" clearable filterable @change="">
                    <el-option v-for="item in options.pre_sale_principal"
                        :key="item"
                        :value="item">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="预计开始时间" size="small">
                <el-date-picker
                    v-model="form.estimate_start_date"
                    type="date"
                    value-format="yyyy-MM-dd"
                    placeholder="选择日期">
                </el-date-picker>
            </el-form-item>
            <el-form-item label="预计投入人日" size="small">
                <el-input v-model.number="form.man_day" placeholder="请输入" style="width: 220px"></el-input>
            </el-form-item>
            <el-form-item label="任务类型" size="small">
                <el-select v-model="form.task_type" placeholder="请选择" clearable filterable @change="">
                    <el-option v-for="item in options.pre_sale_task_type"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="优先级" size="small">
                <el-select v-model="form.priority" placeholder="请选择" clearable filterable @change="">
                    <el-option v-for="item in options.presale_task_priority"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="addPreSale">确 定</el-button>
        </span>
    </el-dialog>
</template>

<script>
import { getPreSaleOptionInfo } from '../../../api/api'
export default {
    props: {
        value: {
            type: Boolean,
            default: false,
            required: true
        },
        title: {
            type: String,
            default: '申请售前介入任务'
        }
    },
    data() {
        return {
            dialogFormVisible: false,
            form: {},
            loading: false,
            options: {
                pre_sale_principal: [],
                pre_sale_task_type: []
            }
        }
    },
    watch: {
        value(newVal) {
            this.dialogFormVisible = newVal
        }
    },
    methods: {
        getPreSaleOption() {
            getPreSaleOptionInfo({}).then(result => {
                const res = result.data
                if (res.respCode === '000000') {
                    this.options = res.respData
                }
            })
        },
        addPreSale() {
            const fieldMap = ['pre_sale_principal', 'estimate_start_date', 'man_day', 'task_type', 'priority']
            for (const key of fieldMap) {
                if (!this.form[key]) {
                    this.$message.warning('请填写完整信息')
                    return
                }
            }
            this.$emit('submit', this.form)
            this.$emit('input', false)
        }
    },
    created () {
        this.getPreSaleOption()
    },
}
</script>

<style lang="scss" scoped>
</style>